import React from "react";
import { Trans } from "tsi-common-react/src/common/Trans";
import { t } from "ttag";

import { useAppSelector } from "../../hooks";
import { CMSFlagshipStore } from "../components/CMSFlagshipStore";
import { FlagshipStore } from "../components/FlagshipStore";
import {
    nearestFlagshipStorePageSelector,
    nearestFlagshipStoreSelector,
} from "../selectors";
import { getTodayHoursKey } from "../utils";

interface IProps {
    productTitle: string | null;
    displayEmptyState: (state: boolean) => void;
}

export const NearbyFlagshipStores = (props: IProps): React.ReactNode => {
    const { productTitle, displayEmptyState } = props;
    const store = useAppSelector(nearestFlagshipStoreSelector);
    const storePage = useAppSelector(nearestFlagshipStorePageSelector);
    const hasMountedRef = React.useRef(false);

    React.useEffect(() => {
        if (!hasMountedRef.current) {
            hasMountedRef.current = true;
            return;
        }
        // Match the previous componentDidUpdate-only lifecycle.
        displayEmptyState(!store);
    });

    if (!store) {
        return (
            <p>
                <span>
                    <Trans
                        fmtString={t`Please enter a ZIP Code above to find where you can test a <ProductTitle></ProductTitle>.`}
                        data={{
                            ProductTitle: () => (
                                <strong key="1">{productTitle}</strong>
                            ),
                        }}
                    />
                </span>
            </p>
        );
    }

    if (!storePage) {
        return <FlagshipStore store={store} />;
    }

    return (
        <CMSFlagshipStore
            store={store}
            cmsProps={storePage}
            hoursFieldName={getTodayHoursKey()}
        />
    );
};
